import axios from 'axios'
axios.defaults.headers.post['Content-Type'] = 'application/json'

const api = axios.create({
  baseURL: process.env.REACT_APP_ROOT_API,
  headers: {
    'x-device': 'web',
    crossDomain: true,
  },
})

export default api
